import { ArticleType } from "../../../../../__generated__/gql/graphql";

const articleTypeOptions: Record<ArticleType, string> = {
  [ArticleType.HowToGuide]: "How-to-Guide",
  [ArticleType.Listicle]: "Listicle",
  [ArticleType.Overview]: "Overview",
};

export default articleTypeOptions;
